import { React, useState, useEffect } from 'react';
import { searchIcon } from '../component/ImageList';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFilter } from '../context/FilterContext';
import { useTranslation } from 'react-i18next';
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';
import { ReactNotifications } from 'react-notifications-component';
import ProfilePopup from '../component/ProfilePopup';
export default function FilterList() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isFilterPopupOpen, openFilterPopup, closeFilterPopup, toggleFilterPopup } = useFilter();
    const [isScrollFixed, setIsScrollFixed] = useState(false);
    const [showBackToTop, setShowBackToTop] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const { t } = useTranslation();
    const [userid, setUserid] = useState(null);
    const [agentkey, setAgentkey] = useState(null);
    const [result, setResult] = useState(null);
    const [agentID, setAgentID] = useState("");
    const [visibleProjects, setVisibleProjects] = useState(false);
    const [visibleListings, setVisibleListings] = useState(true);
    const [nodataCheck, setNodataCheck] = useState(false);
    const [propertyTypeData, setPropertyTypeData] = useState([]);
    const [originalPropertyList, setOriginalPropertyList] = useState([]);
    const [selectedPropertyType, setSelectedPropertyType] = useState(null);
    const [selectedRooms, setSelectedRooms] = useState(null);
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [animatedPlaceholder, setAnimatedPlaceholder] = useState('');
    const [isInputFocused, setIsInputFocused] = useState(false);
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [consumerFirstName, setConsumerFirstName] = useState('');
    const [consumerLastName, setConsumerLastName] = useState('');
    const [consumerEmail, setConsumerEmail] = useState('');
    const [consumerPhone, setConsumerPhone] = useState('');
    const [consumerProfileImage, setConsumerProfileImage] = useState('');
    const [visibleCards, setVisibleCards] = useState(new Set());
    const [hoveredCardId, setHoveredCardId] = useState(null);
    const [isLoadingProperties, setIsLoadingProperties] = useState(true);
    const [filterId, setFilterId] = useState('');

    // Load profile image from localStorage on mount
    useEffect(() => {
        const loadProfileImage = () => {
            // Priority: profileImage (updated) > consumerProfileImage (from API)
            const profileImage = localStorage.getItem('profileImage') || localStorage.getItem('consumerProfileImage') || '';
            if (profileImage) {
                const imageWithTimestamp = profileImage + (profileImage.includes('?') ? '&' : '?') + 't=' + Date.now();
                setConsumerProfileImage(imageWithTimestamp);
            }
        };
        loadProfileImage();

        // Listen for profile data updates
        const handleProfileDataUpdate = () => {
            loadProfileImage();
        };
        window.addEventListener('profileDataUpdated', handleProfileDataUpdate);

        return () => {
            window.removeEventListener('profileDataUpdated', handleProfileDataUpdate);
        };
    }, []);

    // Typing animation for placeholder
    useEffect(() => {
        if (isInputFocused || searchQuery.trim()) {
            // Stop animation when input is focused or has value
            return;
        }

        const fullPlaceholder = t('quickSearch') + " (with Postal Code, Street Name, City Name, Property Type)";

        if (placeholderIndex < fullPlaceholder.length) {
            // Typing forward
            const timer = setTimeout(() => {
                setAnimatedPlaceholder(fullPlaceholder.substring(0, placeholderIndex + 1));
                setPlaceholderIndex(prev => prev + 1);
            }, 100); // Typing speed: 100ms per character
            return () => clearTimeout(timer);
        } else {
            // Finished typing, wait then restart from beginning
            const waitTimer = setTimeout(() => {
                setAnimatedPlaceholder('');
                setPlaceholderIndex(0);
            }, 2000); // Wait 2 seconds before restarting
            return () => clearTimeout(waitTimer);
        }
    }, [placeholderIndex, isInputFocused, searchQuery, t]);

    // Check authentication on component mount
    useEffect(() => {
        const userID = localStorage.getItem('userID');
        setUserid(userID);
        const agentkey = localStorage.getItem('agentKey');
        setAgentkey(agentkey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);

        const filterid = location.state.filterId;
        console.log(filterid);
        setFilterId(filterid);

        // If userID or agentKey is missing, redirect to login page
        if (!userID || !agentkey) {
            navigate('/');
        }
        // getAgentDetails(userID, agentKey);
        fetchPropertyTypes(userID);
        fetchDetailsAPI(userID);
        fetchFilterListAPI(userID, agentid, filterid);
    }, [navigate]);
    const [propertyList, setPropertyList] = useState([]);

    const handleFilterPopup = () => {
        toggleFilterPopup();
    }

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrollFixed(true);
            } else {
                setIsScrollFixed(false);
            }

            // Show back to top button when scrolled down more than 300px
            if (window.scrollY > 300) {
                setShowBackToTop(true);
            } else {
                setShowBackToTop(false);
            }
        }

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    // Close filter popup when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            const filterPopup = document.getElementById('filterPopup');
            const searchFilterBtn = document.querySelector('.search-filter-btn');
            const mobileFilterBtn = document.querySelector('.mobile-filter-btn');

            if (isFilterPopupOpen &&
                filterPopup &&
                !filterPopup.contains(event.target) &&
                !searchFilterBtn?.contains(event.target) &&
                !mobileFilterBtn?.contains(event.target)) {
                closeFilterPopup();
            }
        };

        if (isFilterPopupOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isFilterPopupOpen, closeFilterPopup]);



    const formatPrice = (price) => {
        if (price === null || price === undefined) {
            return '';
        }

        const priceString = price.toString();
        const match = priceString.match(/^(\D*)(\d+)(.*)$/);

        if (!match) {
            return priceString;
        }

        const [, prefix, digits, suffix] = match;
        const formattedDigits = digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return `${prefix}${formattedDigits}${suffix}`;
    };

    function fetchFilterListAPI(userID, agentID, filterid) {
        // console.log(userID)
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("filter_id", filterid)
        formdata.append("agent_id", agentID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        fetch(baseURL.URL + '/consumer_portfolio/filtered_portfolio', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson.response.portfolios
                console.log(result)
                if (responseJson.server.code === 200) {
                    setOriginalPropertyList(result);
                    setPropertyList(result);
                    setIsLoadingProperties(false);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                showNotification('Error', 'Something went wrong while fetching filter list', 'danger');
                console.error(error);
            });
    }




    function makeFav(listingId) {
        if (!listingId || !userid || !agentID) {
            console.warn('Missing data to mark favorite', { listingId, userid, agentID });
            return;
        }

        // Find the property in the list
        const propertyIndex = propertyList.findIndex(p => p.listing_id === listingId);
        if (propertyIndex === -1) {
            console.warn('Property not found in list', listingId);
            return;
        }

        const property = propertyList[propertyIndex];
        const isCurrentlyFavorite = property.is_favorite == '1';
        const newFavoriteStatus = isCurrentlyFavorite ? '0' : '1';

        // Store original state for potential rollback
        const previousPropertyList = [...propertyList];
        const previousOriginalPropertyList = [...originalPropertyList];

        // Optimistically update the local state for both propertyList and originalPropertyList
        const updatedPropertyList = [...propertyList];
        updatedPropertyList[propertyIndex] = {
            ...property,
            is_favorite: newFavoriteStatus
        };
        setPropertyList(updatedPropertyList);

        // Also update originalPropertyList
        const originalPropertyIndex = originalPropertyList.findIndex(p => p.listing_id === listingId);
        if (originalPropertyIndex !== -1) {
            const updatedOriginalPropertyList = [...originalPropertyList];
            updatedOriginalPropertyList[originalPropertyIndex] = {
                ...originalPropertyList[originalPropertyIndex],
                is_favorite: newFavoriteStatus
            };
            setOriginalPropertyList(updatedOriginalPropertyList);
        }

        // Show notification based on favorite status
        if (newFavoriteStatus === '1') {
            showNotification('Success', 'Added to favorites', 'success');
        } else {
            showNotification('Success', 'Removed from favorites', 'success');
        }

        const formdata = new FormData();
        formdata.append("user_id", userid);
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055');
        formdata.append("listing_id", listingId);
        formdata.append("agent_id", agentID);
        formdata.append("is_favorite", newFavoriteStatus);

        fetch(baseURL.URL + '/consumer_portfolio/listing_favorites', {
            method: 'POST',
            body: formdata
        })
            .then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server.code !== 200) {
                    // Revert the optimistic update on error
                    setPropertyList(previousPropertyList);
                    setOriginalPropertyList(previousOriginalPropertyList);
                    showNotification('Error', responseJson.server.message || 'Unable to update favorite', 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                // Revert the optimistic update on error
                setPropertyList(previousPropertyList);
                setOriginalPropertyList(previousOriginalPropertyList);
                showNotification('Error', 'Something went wrong while updating favorite', 'danger');
            });
    }


    function fetchPropertyTypes(userID) {
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        fetch(baseURL.URL + '/portfolio/before_add_listing_fetch_fields', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const property_type = responseJson.response.property_type
                if (responseJson.server.code === 200) {
                    setPropertyTypeData(property_type)
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger')
                }
            })
            .catch((error) => {
                console.error(error);
            });
    }

    function fetchDetailsAPI(userID) {
        // console.log('USER ID ============== ' + this.state.userID)
        // const { navigate } = this.props.navigation;
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        fetch(baseURL.URL + '/consumers/get_consumer_details', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson
                if (responseJson.server.code === 200) {
                    localStorage.setItem('consumerFirstName', responseJson.response.fname);
                    localStorage.setItem('consumerLastName', responseJson.response.lname);
                    localStorage.setItem('consumerEmail', responseJson.response.email);
                    localStorage.setItem('consumerPhone', responseJson.response.phone);

                    // Check if there's an updated profile image in localStorage (from Profile page upload)
                    const updatedProfileImage = localStorage.getItem('conProfileImage');
                    // Use updated image if available, otherwise use API response
                    const profileImageToUse = updatedProfileImage || responseJson.response.picture || '';

                    localStorage.setItem('consumerProfileImage', profileImageToUse);
                    // Also update profileImage if it doesn't exist or if API has newer version
                    if (!updatedProfileImage) {
                        localStorage.setItem('conProfileImage', responseJson.response.picture || '');
                    }

                    setConsumerFirstName(responseJson.response.fname);
                    setConsumerLastName(responseJson.response.lname);
                    setConsumerEmail(responseJson.response.email);
                    setConsumerPhone(responseJson.response.phone);
                    // Add timestamp to prevent caching
                    const imageWithTimestamp = profileImageToUse ? (profileImageToUse + (profileImageToUse.includes('?') ? '&' : '?') + 't=' + Date.now()) : '';
                    setConsumerProfileImage(imageWithTimestamp);

                    // Dispatch event to update Header component
                    window.dispatchEvent(new Event('profileDataUpdated'));


                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while fetching details', 'danger');
            });
    }

    // Reset filters
    const resetFilters = () => {
        setSelectedPropertyType(null);
        setSelectedRooms(null);
        setMinPrice('');
        setMaxPrice('');
        setSearchQuery('');
    };

    // Apply filters when filter values change
    useEffect(() => {
        if (originalPropertyList.length === 0) return;

        let filtered = [...originalPropertyList];

        // Filter by property type
        if (selectedPropertyType) {
            filtered = filtered.filter(property =>
                property.PropertyType === selectedPropertyType
            );
        }

        // Filter by rooms (bedrooms)
        if (selectedRooms) {
            const roomsNum = parseInt(selectedRooms);
            filtered = filtered.filter(property => {
                const bedrooms = parseInt(property.BedroomsTotal) || 0;
                return bedrooms >= roomsNum;
            });
        }

        // Filter by price range
        if (minPrice) {
            const min = parseFloat(minPrice.replace(/[^\d.]/g, ''));
            if (!isNaN(min)) {
                filtered = filtered.filter(property => {
                    const price = parseFloat(property.ListPrice?.toString().replace(/[^\d.]/g, '') || 0);
                    return price >= min;
                });
            }
        }

        if (maxPrice) {
            const max = parseFloat(maxPrice.replace(/[^\d.]/g, ''));
            if (!isNaN(max)) {
                filtered = filtered.filter(property => {
                    const price = parseFloat(property.ListPrice?.toString().replace(/[^\d.]/g, '') || 0);
                    return price <= max;
                });
            }
        }

        // Filter by search query (PostalCode, city_name, PropertyType, StreetName)
        if (searchQuery.trim()) {
            const query = searchQuery.trim().toLowerCase();
            filtered = filtered.filter(property => {
                const postalCode = (property.PostalCode || '').toString().toLowerCase();
                const cityName = (property.city_name || '').toString().toLowerCase();
                const propertyType = (property.PropertyType || '').toString().toLowerCase();
                const streetName = (property.StreetName || '').toString().toLowerCase();

                return postalCode.includes(query) ||
                    cityName.includes(query) ||
                    propertyType.includes(query) ||
                    streetName.includes(query);
            });
        }

        setPropertyList(filtered);
    }, [selectedPropertyType, selectedRooms, minPrice, maxPrice, searchQuery, originalPropertyList]);

    // Intersection Observer for fade-up animation on scroll
    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const cardId = entry.target.getAttribute('data-card-id');
                    if (cardId) {
                        setVisibleCards(prev => new Set([...prev, cardId]));
                    }
                }
            });
        }, observerOptions);

        // Observe all property cards
        const cards = document.querySelectorAll('[data-card-id]');
        cards.forEach(card => observer.observe(card));

        return () => {
            cards.forEach(card => observer.unobserve(card));
        };
    }, [propertyList]);

    return (
        <>
            <ReactNotifications />
            {/* <!-- Search Section --> */}
            <section className={`search-section ${isScrollFixed ? 'fixedScroll' : ''}`}>
                <div className="container">
                    <div className="back-btn" aria-label="Back" onClick={() => navigate(-1)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M12.5 15L7.5 10L12.5 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div className="search-bar" style={{ position: 'relative' }}>
                        <div className='search-icon'>
                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                <path d="M18.7455 18.0975L15.1647 14.5166C16.2637 13.2634 16.8701 11.6776 16.8701 9.99516C16.8701 8.15869 16.1549 6.43233 14.8564 5.13387C13.5579 3.83541 11.8316 3.12016 9.99512 3.12016C8.15865 3.12016 6.43229 3.83541 5.13383 5.13387C3.83537 6.43233 3.12012 8.15869 3.12012 9.99516C3.12012 11.8316 3.83537 13.558 5.13383 14.8564C6.43229 16.1549 8.15865 16.8702 9.99512 16.8702C11.6775 16.8702 13.2633 16.2638 14.5166 15.1647L18.0974 18.7456C18.1869 18.8351 18.3042 18.8798 18.4215 18.8798C18.5387 18.8798 18.656 18.8351 18.7455 18.7456C18.9246 18.5665 18.9246 18.2765 18.7455 18.0975ZM5.78194 14.2083C4.6567 13.0829 4.03678 11.5866 4.03678 9.99516C4.03678 8.40375 4.6567 6.90745 5.78194 5.78198C6.90741 4.65674 8.40371 4.03683 9.99512 4.03683C11.5865 4.03683 13.0828 4.65674 14.2083 5.78198C15.3335 6.90745 15.9535 8.40375 15.9535 9.99516C15.9535 11.5866 15.3335 13.0829 14.2083 14.2083C13.0828 15.3336 11.5865 15.9535 9.99512 15.9535C8.40371 15.9535 6.90741 15.3336 5.78194 14.2083Z" fill="black" fill-opacity="0.35" />
                            </svg>
                        </div>
                        <input
                            type="text"
                            placeholder={animatedPlaceholder || (t('quickSearch') + " (with Postal Code, Street Name, City Name, Property Type)")}
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onFocus={() => setIsInputFocused(true)}
                            onBlur={() => setIsInputFocused(false)}
                            style={{ paddingRight: searchQuery.trim() ? '40px' : '' }}
                        />
                        {searchQuery.trim() && (
                            <button
                                onClick={() => setSearchQuery('')}
                                style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '5px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 10
                                }}
                                aria-label="Clear search"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'rgba(0, 0, 0, 0.5)' }} />
                                </svg>
                            </button>
                        )}
                    </div>
                    <button className="search-filter-btn" onClick={() => handleFilterPopup()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4062 4.69699C14.5256 4.69699 12.9441 6.04497 12.5793 7.82199H2.34375C1.91228 7.82199 1.5625 8.17178 1.5625 8.60324C1.5625 9.03471 1.91228 9.38449 2.34375 9.38449H12.5793C12.9441 11.1615 14.5256 12.5095 16.4062 12.5095C18.2869 12.5095 19.8684 11.1615 20.2332 9.38449H22.6562C23.0877 9.38449 23.4375 9.03471 23.4375 8.60324C23.4375 8.17178 23.0877 7.82199 22.6562 7.82199H20.2332C19.8684 6.04497 18.2869 4.69699 16.4062 4.69699ZM16.4062 6.25949C17.7099 6.25949 18.75 7.2996 18.75 8.60324C18.75 9.90689 17.7099 10.947 16.4062 10.947C15.1026 10.947 14.0625 9.90689 14.0625 8.60324C14.0625 7.2996 15.1026 6.25949 16.4062 6.25949Z" fill="white" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.59375 12.5095C6.71313 12.5095 5.1316 13.8575 4.76685 15.6345H2.34375C1.91228 15.6345 1.5625 15.9843 1.5625 16.4157C1.5625 16.8472 1.91228 17.197 2.34375 17.197H4.76685C5.1316 18.974 6.71313 20.322 8.59375 20.322C10.4744 20.322 12.0559 18.974 12.4207 17.197H22.6562C23.0877 17.197 23.4375 16.8472 23.4375 16.4157C23.4375 15.9843 23.0877 15.6345 22.6562 15.6345H12.4207C12.0559 13.8575 10.4744 12.5095 8.59375 12.5095ZM8.59375 14.072C9.8974 14.072 10.9375 15.1121 10.9375 16.4157C10.9375 17.7194 9.8974 18.7595 8.59375 18.7595C7.2901 18.7595 6.25 17.7194 6.25 16.4157C6.25 15.1121 7.2901 14.072 8.59375 14.072Z" fill="white" />
                        </svg>
                    </button>
                    {/* <!-- Filter Popup --> */}
                    <div className="filter-popup" id="filterPopup" style={{ display: isFilterPopupOpen ? 'block' : 'none' }}>
                        <div className="filter-popup-content">
                            <div className="filter-popup-row">
                                <div className="filter-popup-section">
                                    <h3 className="filter-popup-heading">{t('propertyType')}</h3>
                                    <div className="option-buttons">
                                        {propertyTypeData.map((type) => (
                                            <button
                                                key={type.id}
                                                className={`option-btn ${selectedPropertyType === type.type ? 'active' : ''}`}
                                                onClick={() => setSelectedPropertyType(selectedPropertyType === type.type ? null : type.type)}
                                            >
                                                {type.type}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="filter-popup-row rooms-row">
                                <div className="filter-popup-section rooms-section">
                                    <button className="rooms-label-btn active">{t('rooms')}</button>
                                    <button
                                        className={`option-btn ${selectedRooms === '1' ? 'active' : ''}`}
                                        onClick={() => setSelectedRooms(selectedRooms === '1' ? null : '1')}
                                    >
                                        1
                                    </button>
                                    <button
                                        className={`option-btn ${selectedRooms === '2' ? 'active' : ''}`}
                                        onClick={() => setSelectedRooms(selectedRooms === '2' ? null : '2')}
                                    >
                                        2
                                    </button>
                                    <button
                                        className={`option-btn ${selectedRooms === '3' ? 'active' : ''}`}
                                        onClick={() => setSelectedRooms(selectedRooms === '3' ? null : '3')}
                                    >
                                        3
                                    </button>
                                    <button
                                        className={`option-btn ${selectedRooms === '4' ? 'active' : ''}`}
                                        onClick={() => setSelectedRooms(selectedRooms === '4' ? null : '4')}
                                    >
                                        4
                                    </button>
                                    <button
                                        className={`option-btn ${selectedRooms === '5' ? 'active' : ''}`}
                                        onClick={() => setSelectedRooms(selectedRooms === '5' ? null : '5')}
                                    >
                                        5
                                    </button>
                                </div>
                            </div>

                            <div className="filter-popup-row price-row">
                                <div className="filter-popup-section price-section">
                                    <h3 className="filter-popup-heading">{t('price')}</h3>
                                    <div className="price-inputs">
                                        <input
                                            type="text"
                                            className="filter-input"
                                            placeholder="Min Value"
                                            value={minPrice}
                                            onChange={(e) => setMinPrice(e.target.value)}
                                        />
                                        <input
                                            type="text"
                                            className="filter-input"
                                            placeholder="Max Value"
                                            value={maxPrice}
                                            onChange={(e) => setMaxPrice(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="filter-popup-actions" style={{ padding: '15px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                                <button
                                    className="btn-secondary"
                                    onClick={resetFilters}
                                    style={{ padding: '8px 16px', cursor: 'pointer' }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Active Filters Display --> */}
            {(selectedPropertyType || selectedRooms || minPrice || maxPrice) && (
                <section className="active-filters-section" style={{ padding: '15px 0', background: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                    <div className="container">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                            <span style={{ fontWeight: '600', marginRight: '10px' }}>Active Filters:</span>

                            {selectedPropertyType && (
                                <span className="filter-tag" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 12px',
                                    background: '#1C4CAF',
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontSize: '14px'
                                }}>
                                    <span>Property Type: {selectedPropertyType}</span>
                                    <button
                                        onClick={() => setSelectedPropertyType(null)}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            padding: '0',
                                            marginLeft: '5px',
                                            fontSize: '16px',
                                            lineHeight: '1'
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}

                            {selectedRooms && (
                                <span className="filter-tag" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 12px',
                                    background: '#1C4CAF',
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontSize: '14px'
                                }}>
                                    <span>Rooms: {selectedRooms}+</span>
                                    <button
                                        onClick={() => setSelectedRooms(null)}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            padding: '0',
                                            marginLeft: '5px',
                                            fontSize: '16px',
                                            lineHeight: '1'
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}

                            {minPrice && (
                                <span className="filter-tag" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 12px',
                                    background: '#1C4CAF',
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontSize: '14px'
                                }}>
                                    <span>Min Price: {minPrice}</span>
                                    <button
                                        onClick={() => setMinPrice('')}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            padding: '0',
                                            marginLeft: '5px',
                                            fontSize: '16px',
                                            lineHeight: '1'
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}

                            {maxPrice && (
                                <span className="filter-tag" style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 12px',
                                    background: '#1C4CAF',
                                    color: 'white',
                                    borderRadius: '20px',
                                    fontSize: '14px'
                                }}>
                                    <span>Max Price: {maxPrice}</span>
                                    <button
                                        onClick={() => setMaxPrice('')}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: 'white',
                                            cursor: 'pointer',
                                            padding: '0',
                                            marginLeft: '5px',
                                            fontSize: '16px',
                                            lineHeight: '1'
                                        }}
                                    >
                                        ×
                                    </button>
                                </span>
                            )}

                            <button
                                onClick={resetFilters}
                                style={{
                                    marginLeft: 'auto',
                                    padding: '6px 12px',
                                    background: 'transparent',
                                    border: '1px solid #1C4CAF',
                                    color: '#1C4CAF',
                                    borderRadius: '20px',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Clear All
                            </button>
                        </div>
                    </div>
                </section>
            )}
            <ProfilePopup />
            {/* <!-- Main Content --> */}
            <main className="main-content">
                <div className="container">


                    {selectedProperty && (
                        <div className="property-details-popup">
                            <h2>{selectedProperty.title}</h2>
                            <p>{selectedProperty.description}</p>
                        </div>
                    )}

                    {isLoadingProperties ? (
                        <div className='loading-filters' style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#666'
                        }}>
                            <div style={{
                                width: '50px',
                                height: '50px',
                                border: '4px solid #f3f3f3',
                                borderTop: '4px solid #1C4CAF',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{t('loading')}</h3>
                            <p style={{ fontSize: '16px', color: '#999' }}>{t('pleaseWaitWhileWeFetchTheFilters')}</p>
                        </div>
                    ) : propertyList.length === 0 ? (
                        <div className='loading-filters' style={{
                            textAlign: 'center',
                            padding: '60px 20px',
                            color: '#666'
                        }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 20px', opacity: 0.5 }}>
                                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor" />
                            </svg>
                            <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{t('noDataFound')}</h3>
                            <p style={{ fontSize: '16px', color: '#999' }}>
                                {selectedPropertyType || selectedRooms || minPrice || maxPrice || searchQuery.trim()
                                    ? t('noPropertiesMatchYourCurrentFiltersTryAdjustingYourSearchCriteria')
                                    : t('noPropertiesAvailableAtTheMoment')}
                            </p>
                        </div>
                    ) : (
                        <div className="property-grid">
                            {propertyList.map((property, index) => (
                                <div
                                    key={property.listing_id}
                                    data-card-id={property.listing_id}
                                    className={`property-card cursor-pointer ${visibleCards.has(property.listing_id) ? 'animate-fade-up opacity-100' : 'opacity-0'} ${hoveredCardId && hoveredCardId !== property.listing_id ? 'card-dimmed' : ''} ${hoveredCardId === property.listing_id ? 'card-hovered' : ''}`}
                                    onClick={() => navigate('/details', {
                                        state: {
                                            listingID: property.listing_id,
                                        }
                                    })}
                                    onMouseEnter={() => setHoveredCardId(property.listing_id)}
                                    onMouseLeave={() => setHoveredCardId(null)}
                                >
                                    <div className={`property-image ${selectedProperty === property.listing_id ? 'selected' : ''}`}>
                                        <img src={property.image} alt={property.title} />

                                        <button className={`favorite-btn ${property.is_favorite == '1' ? 'active' : ''}`} onClick={(event) => {
                                            event.stopPropagation();
                                            makeFav(property.listing_id);
                                        }}>

                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                                                <path d="M0 5.85219C0 10.7151 4.01943 13.3065 6.96173 15.626C8 16.4445 9 17.2151 10 17.2151C11 17.2151 12 16.4445 13.0383 15.626C15.9806 13.3065 20 10.7151 20 5.85219C20 0.98925 14.4998 -2.45945 10 2.21572C5.50016 -2.45945 0 0.98925 0 5.85219Z" fill="white" />
                                            </svg>


                                        </button>

                                        <div className="status">

                                            {property.StandardStatus === 'Active' && (
                                                <>
                                                    <span className="status-dot active"></span>
                                                    <span>{property.StandardStatusName}</span>
                                                </>
                                            )}
                                            {property.StandardStatus === 'Coming Soon' && (
                                                <>
                                                    <span className="status-dot coming-soon"></span>
                                                    <span>{property.StandardStatusName}</span>
                                                </>
                                            )}
                                            {property.StandardStatus === 'Sold' && (
                                                <>
                                                    <span className="status-dot sold"></span>
                                                    <span>{property.StandardStatusName}</span>
                                                </>
                                            )}
                                            {property.StandardStatus === 'Cancelled' && (
                                                <>
                                                    <span className="status-dot cancelled"></span>
                                                    <span>{property.StandardStatusName}</span>
                                                </>
                                            )}
                                            {property.StandardStatus === 'Under Offer' && (
                                                <>
                                                    <span className="status-dot under-offer"></span>
                                                    <span>{property.StandardStatusName}</span>
                                                </>
                                            )}

                                            {property.StandardStatus === '' || property.StandardStatus === null || property.StandardStatus === 'asd' || property.StandardStatus === '1' && (
                                                <>
                                                    <span className="status-dot"></span>
                                                    <span>{property.StandardStatusName || 'N/A'}</span>
                                                </>
                                            )}

                                        </div>
                                    </div>
                                    <div className="property-content">
                                        <h3 className="property-title">{property.PostalCode} {property.city_name} <span className="type ml-4">{property.PropertyType}</span></h3>
                                        <div className="location">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fillOpacity="0.35" />
                                            </svg>
                                            <span>{property.StreetName} {property.StreetNumber}</span>
                                        </div>
                                        <div className="property-details">
                                            <div className="detail-row">
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                        <g clipPath="url(#clip0_405_733)">
                                                            <path d="M9.68521 11.0902L2.66029 7.27238C2.34781 7.10264 1.97881 7.10965 1.67304 7.29142C1.36727 7.47314 1.18481 7.794 1.18481 8.14972V17.0062C1.18481 17.3645 1.37832 17.6972 1.68985 17.8743L8.7149 21.868C8.86977 21.956 9.03911 22 9.20851 22C9.38112 22 9.55369 21.9543 9.71062 21.863C10.0214 21.6822 10.207 21.3595 10.207 20.9999V11.9676C10.207 11.6013 10.0071 11.2651 9.68521 11.0902Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M19.5402 4.96845C19.5397 4.59451 19.3332 4.25534 19.0012 4.08328L11.3408 0.111819C11.0507 -0.0386167 10.705 -0.0374991 10.416 0.114613L2.86825 4.08608C2.53961 4.25908 2.33519 4.59721 2.33472 4.96862C2.33429 5.33994 2.53789 5.67855 2.86606 5.85228L10.4139 9.84854C10.56 9.92587 10.7205 9.96455 10.881 9.96455C11.0396 9.96455 11.1982 9.92681 11.3429 9.8513L19.0035 5.85512C19.335 5.68216 19.5407 5.34239 19.5402 4.96845Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M20.3267 7.2914C20.0211 7.10963 19.6519 7.10245 19.3395 7.27232L12.3144 11.0902C11.9926 11.2651 11.7927 11.6013 11.7927 11.9675V20.9998C11.7927 21.3594 11.9783 21.6821 12.2891 21.8629C12.446 21.9543 12.6185 21.9999 12.7912 21.9999C12.9605 21.9999 13.13 21.9559 13.2848 21.8679L20.3099 17.8742C20.6214 17.6971 20.8149 17.3645 20.8149 17.0061V8.1497C20.8149 7.79398 20.6324 7.47313 20.3267 7.2914Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_733_${property.id}`}>
                                                                <rect width="22" height="22" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{property.LivingArea || 'N/A'} {property.LivingAreaUnits == "Sq Meter" ? "m" : "f"}<sup className=''>2</sup></span>
                                                </div>
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <g clipPath={`url(#clip0_405_741_${property.id})`}>
                                                            <path d="M2.47178 13.9166V6.1042C2.47178 5.5634 2.03338 5.125 1.49263 5.125C0.951828 5.125 0.513428 5.5634 0.513428 6.1042V18.8958C0.513428 19.4366 0.951828 19.875 1.49263 19.875C2.03338 19.875 2.47178 19.4366 2.47178 18.8958V17.0614L22.5282 17.0142V18.8487C22.5282 19.3895 22.9666 19.8279 23.5074 19.8279C24.0481 19.8279 24.4865 19.3895 24.4865 18.8487V17.0142V14.4529V13.8695L2.47178 13.9166Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M24.4865 13.0779H9.60107V9.39035C9.60107 8.3203 10.4685 7.45285 11.5386 7.45285H20.575C22.7353 7.45285 24.4865 9.20405 24.4865 11.3643V13.0779Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M6.11706 12.656C7.4373 12.656 8.50756 11.5857 8.50756 10.2655C8.50756 8.94526 7.4373 7.875 6.11706 7.875C4.79683 7.875 3.72656 8.94526 3.72656 10.2655C3.72656 11.5857 4.79683 12.656 6.11706 12.656Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_741_${property.id}`}>
                                                                <rect width="25" height="25" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{property.BedroomsTotal}</span>
                                                </div>

                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <g clipPath={`url(#clip0_405_749_${property.id})`}>
                                                            <path d="M3.10162 23.8612C2.87721 24.1978 2.96818 24.6526 3.30475 24.8769C3.42965 24.9602 3.57076 25 3.71036 25C3.94703 25 4.17931 24.8855 4.32042 24.6737L4.87863 23.8364C4.42677 23.6381 3.99625 23.3999 3.59205 23.1255L3.10162 23.8612Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M21.4082 23.1255C21.004 23.3999 20.5735 23.6381 20.1216 23.8364L20.6798 24.6737C20.8209 24.8855 21.0531 25 21.2898 25C21.4294 25 21.5706 24.9602 21.6955 24.8769C22.0321 24.6526 22.123 24.1978 21.8986 23.8612L21.4082 23.1255Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M1.51367 14.1671V16.4551C1.51367 20.0898 4.47075 23.0469 8.10547 23.0469H16.8945C20.5292 23.0469 23.4863 20.0898 23.4863 16.4551V16.0286H11.3839C7.97895 16.0286 4.6646 15.4025 1.51367 14.1671Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M3.95483 8.63228V2.68555C3.95483 2.01245 4.50244 1.46484 5.17554 1.46484H6.1521C6.8252 1.46484 7.3728 2.01245 7.3728 2.68555V3.03306C6.24058 3.35928 5.41968 4.42187 5.41968 5.65601V5.85938C5.41968 6.26387 5.74761 6.5918 6.1521 6.5918H10.0583C10.4628 6.5918 10.7908 6.26387 10.7908 5.85938V5.61523C10.7908 4.38833 9.96348 3.35156 8.83765 3.03188V2.68555C8.83765 1.20474 7.63291 0 6.1521 0H5.17554C3.69473 0 2.48999 1.20474 2.48999 2.68555V8.04414C2.60532 8.07959 2.71919 8.12124 2.83096 8.1708C3.20249 8.33594 3.57725 8.4895 3.95483 8.63228Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M23.3947 11.451H11.384C8.21198 11.451 5.13517 10.7979 2.23776 9.5101C1.45095 9.16156 0.53244 9.51469 0.183368 10.2999C-0.165705 11.0852 0.187909 12.0053 0.973211 12.3543C4.2714 13.8205 7.77375 14.5638 11.3841 14.5638H23.3948C24.2546 14.5638 24.9512 13.8671 24.9512 13.0074C24.9511 12.1476 24.2545 11.451 23.3947 11.451Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_749_${property.id}`}>
                                                                <rect width="25" height="25" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{property.BathroomsTotalInteger}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <path d="M3.12492 20.5448V21.875C3.12492 22.1512 3.23467 22.4162 3.43001 22.6116C3.62537 22.8069 3.89031 22.9167 4.16659 22.9167H5.20825C5.48452 22.9167 5.74947 22.8069 5.94483 22.6116C6.14017 22.4162 6.24992 22.1512 6.24992 21.875V20.8333H18.7499V21.875C18.7499 22.1512 18.8597 22.4162 19.055 22.6116C19.2503 22.8069 19.5153 22.9167 19.7916 22.9167H20.8333C21.1095 22.9167 21.3745 22.8069 21.5698 22.6116C21.7651 22.4162 21.8749 22.1512 21.8749 21.875V20.5448C22.191 20.3635 22.4537 20.1022 22.6365 19.7871C22.8194 19.4721 22.916 19.1143 22.9166 18.75V15.625C22.9166 14.7594 22.3885 14.0187 21.6374 13.7031L20.2124 9.42812C20.0058 8.8057 19.608 8.26426 19.0761 7.88073C18.5441 7.4972 17.9047 7.29107 17.2489 7.29166H7.75096C7.09512 7.29107 6.45576 7.4972 5.92375 7.88073C5.39174 8.26426 4.99414 8.8057 4.78742 9.42812L3.36242 13.7031C2.98356 13.8618 2.66003 14.1288 2.43245 14.4708C2.20488 14.8127 2.08339 15.2143 2.08325 15.625V18.75C2.08325 19.5187 2.50409 20.1833 3.12492 20.5448ZM5.72909 18.75C5.52383 18.7499 5.3206 18.7095 5.13098 18.6308C4.94138 18.5522 4.76911 18.437 4.62401 18.2919C4.33099 17.9986 4.16645 17.601 4.16659 17.1865C4.16672 16.7719 4.33153 16.3744 4.62475 16.0813C4.91797 15.7883 5.31559 15.6238 5.73013 15.6239C6.14467 15.6241 6.54217 15.7888 6.8352 16.0821C7.12822 16.3753 7.29276 16.7729 7.29263 17.1875C7.29249 17.6021 7.12768 17.9996 6.83446 18.2926C6.54124 18.5856 6.14363 18.7501 5.72909 18.75ZM19.2708 18.75C18.8562 18.7499 18.4587 18.5851 18.1656 18.2919C17.8726 17.9986 17.7081 17.601 17.7083 17.1865C17.7084 16.7719 17.8731 16.3744 18.1664 16.0813C18.4596 15.7883 18.8572 15.6238 19.2718 15.6239C19.6864 15.6241 20.0839 15.7888 20.3769 16.0821C20.6699 16.3753 20.8344 16.7729 20.8343 17.1875C20.8342 17.6021 20.6694 17.9996 20.3762 18.2926C20.0829 18.5856 19.6853 18.7501 19.2708 18.75ZM7.75096 9.37499H17.2478C17.4666 9.37494 17.6797 9.44373 17.8572 9.57162C18.0346 9.6995 18.1673 9.87999 18.2364 10.0875L19.3885 13.5417H5.61138L6.76242 10.0875C6.90513 9.66145 7.30304 9.37499 7.75096 9.37499Z" fill="black" fillOpacity="0.35" />
                                                        <path d="M22.9166 7.69585V5.49898L12.8291 2.13648C12.6062 2.06186 12.3645 2.06516 12.1437 2.14586L2.08325 5.80419V8.02085L12.5155 4.22711L22.9166 7.69585Z" fill="black" fillOpacity="0.35" />
                                                    </svg>
                                                    <span>{property.GarageSpaces}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="price-type">
                                            <span className="price">€ {formatPrice(property.ListPrice)}</span>

                                        </div>



                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </main >



            {/* Back to Top Button */}
            {
                showBackToTop && (
                    <button
                        onClick={scrollToTop}
                        className="back-to-top-btn"
                        aria-label="Back to top"
                        style={{
                            position: 'fixed',
                            bottom: '100px',
                            right: '30px',
                            width: '50px',
                            height: '50px',
                            borderRadius: '50%',
                            backgroundColor: '#1C4CAF',
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.5)',
                            zIndex: 1000,
                            transition: 'all 0.3s ease',
                            opacity: showBackToTop ? 1 : 0,
                            transform: showBackToTop ? 'translateY(0)' : 'translateY(20px)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#153a8a';
                            e.currentTarget.style.transform = 'translateY(-5px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#1C4CAF';
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 19V5M5 12l7-7 7 7" />
                        </svg>
                    </button>
                )
            }

        </>
    );
}